import { AssemblyPaymentsService }                 from './assembly-payments.service.ajs';
import { AssemblyPaymentsTerminalActionComponent } from './assembly-payments.terminal.actions.component';
import { AssemblyPaymentTerminalModel }            from './models/assembly-payment.terminal';
import { ConfirmService }                          from '../../app-lite/messages/confirm/confirm.service';
import { MessagesService }                         from '../../app-lite/messages/messages.service';
import { Table }                                   from '../../app-lite/table/types/table';
import { TableQueryParameters }                    from '../../app-lite/table/types/table-query-parameters';
import { TableService }                            from '../../app-lite/table/table.service';
import { TableSwitchControlComponent }             from '../../app-lite/table/cell-components/controls/switch-control/table-switch-control.component';

interface AssemblyPaymentsTerminalsScope extends ng.IScope {
  getTerminals  : ( params : TableQueryParameters ) => ng.IPromise<Array<AssemblyPaymentTerminalModel>>;
  pairTerminal  : ( terminal : AssemblyPaymentTerminalModel ) => void;
  removeTerminal: ( terminal : AssemblyPaymentTerminalModel ) => void;
  saveTerminal  : ( terminal : AssemblyPaymentTerminalModel ) => void;
  tableCacheKey : string;
  tableSettings : Table;
  unpairTerminal: ( terminal : AssemblyPaymentTerminalModel ) => void;
}

export function AssemblyPaymentsTerminalsCtrl (
  $state             : ng.ui.IStateService,
  $scope             : AssemblyPaymentsTerminalsScope,
  $translate         : ng.translate.ITranslateService,
  assemblyPaymentsApi: AssemblyPaymentsService,
  confirm            : ConfirmService,
  messages           : MessagesService,
  tableApi           : TableService
) {

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : assemblyPaymentsApi.tableCacheKey
    },
    columns: [
      {
        field : 'ap_pos_id',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.NAME')
        },
      },
      {
        field : 'ap_serial_number',
        header: {
          text: $translate.instant('COMPANY_SPACE.INTEGRATIONS.ASSEMBLY_PAYMENTS.SERIAL_NUMBER')
        },
      },
      {
        field : 'ap_ip_address',
        header: {
          text: $translate.instant('COMPANY_SPACE.INTEGRATIONS.ASSEMBLY_PAYMENTS.WEB_SOCKET_ADDRESS')
        },
      },
      {
        field : 'currentStatus',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
      },
      {
        classes  : 'text-center',
        component: {
          bindings: {
            inputs: {
              disabled: ( terminal : AssemblyPaymentTerminalModel ) => terminal.paired,
              model   : 'ap_print_receipt_from_pos'
            },
            outputs: {
              onChange: ( terminal : AssemblyPaymentTerminalModel ) => $scope.saveTerminal(terminal)
            }
          },
          enabled: true,
          factory: TableSwitchControlComponent
        },
        header: {
          classes: 'text-center',
          text   : 'Print From POS'
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onPairClick  : ( terminal : AssemblyPaymentTerminalModel ) => $scope.pairTerminal(terminal),
              onRemoveClick: ( terminal : AssemblyPaymentTerminalModel ) => $scope.removeTerminal(terminal),
              onUnpairClick: ( terminal : AssemblyPaymentTerminalModel ) => $scope.unpairTerminal(terminal)
            }
          },
          enabled: true,
          factory: AssemblyPaymentsTerminalActionComponent
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TERMINALS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging(assemblyPaymentsApi.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => assemblyPaymentsApi.getTerminalCount()
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache(assemblyPaymentsApi.tableCacheKey, {
      direction: 'asc',
      field    : 'terminal_name'
    }),
  };

  $scope.getTerminals = ( params : TableQueryParameters ) => {
    return assemblyPaymentsApi.getTerminals(params);
  };

  $scope.pairTerminal = function ( terminal : AssemblyPaymentTerminalModel ) : void {
    assemblyPaymentsApi.pairTerminal(terminal)
    .then(() => {
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.removeTerminal = function ( terminal : AssemblyPaymentTerminalModel ) : void {
    assemblyPaymentsApi.deleteTerminal(terminal)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.TERMINAL'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.saveTerminal = function ( terminal : AssemblyPaymentTerminalModel ) : void {
    assemblyPaymentsApi.saveTerminal(terminal)
    .then(() => {
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.unpairTerminal = function ( terminal : AssemblyPaymentTerminalModel ) : void {
    assemblyPaymentsApi.unpairTerminal(terminal)
    .then(() => confirm.notify({
      message: 'Unpairing Successful! Should the EFTPOS terminal remain paired, press Enter + 3 on the EFTPOS terminal to complete unpairing process.'
    }))
    .then(() => {
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  assemblyPaymentsApi.getTerminalCount();
}
